import React from "react";

export default function Resume() {
  return (
    <section style={{
      background: "#0f172a",
      border: "1px solid #1e293b",
      padding: "2rem",
      borderRadius: "12px",
      boxShadow: "0 0 15px rgba(0, 255, 255, 0.08)",
      marginBottom: "2rem",
      textAlign: "center"
    }}>
      <h2 style={{ color: "#00f9ff", fontSize: "1.75rem", fontWeight: "bold" }}>Resume</h2>
      <p style={{ color: "#e2e8f0", marginTop: "1rem" }}>
        Download a copy of my resume for full details on my experience and skills.
      </p>
      <a
        href="/RIMSHA_RAZI_RESUME.pdf"
        download
        style={{
          display: "inline-block",
          marginTop: "1.5rem",
          padding: "12px 24px",
          background: "linear-gradient(to right, #00f9ff, #00aaff)",
          color: "#000",
          borderRadius: "8px",
          fontWeight: "bold",
          textDecoration: "none"
        }}
      >
        📄 Download Resume
      </a>
    </section>
  );
}
